/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Filter_All_ConversationsInputs */



/**
* | output |
* | --- |
* | "All conversations" |
*
* @param {Agenda_Filter_All_ConversationsInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_filter_all_conversations = /** @type {((inputs?: Agenda_Filter_All_ConversationsInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Filter_All_ConversationsInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Alle gesprekken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Toutes les conversations")
	return /** @type {LocalizedString} */ ("All conversations")
});